export default __webpack_public_path__ + "static/media/Visa.b37a5482.svg";